import { useTransition } from '@react-spring/web';
import { SearchItem } from '../../../types/types';

export const useAnimatedSearchItems = (items: SearchItem[]) => {
  const transitions = useTransition(items, {
    keys: (item: SearchItem) =>
      (item as { slug: string; id: string; __typename: string })?.slug ||
      (item as { id: string })?.id ||
      (item as { __typename: string })?.__typename,
    from: {
      opacity: 0,
      transform: 'translateY(20px) scale(0.95)',
    },
    enter: (_: SearchItem, index: number) => ({
      opacity: 1,
      transform: 'translateY(0px) scale(1)',
      delay: index * 100,
    }),
    leave: {
      opacity: 0,
      transform: 'translateY(-20px) scale(0.95)',
    },
    update: {
      opacity: 1,
      transform: 'translateY(0px) scale(1)',
    },
    config: {
      tension: 300,
      friction: 30,
    },
  });

  return transitions;
};
